import React, { useState, useEffect } from 'react'
import { Table } from "react-bootstrap";
import { SuccessToast, ErrorToast } from "app/shared/components/Popups/ToastMessage";
import Axios from "axios";
import fetchUnitList from 'app/views/Admin/CostingMaster/Services/fetchUnitList';
import Url from "app/shared/constants/Url";
import { formatToTwoDecimalPlaces, validateDecimal } from 'app/shared/utility/UtilFunction';
import LoadingView from 'app/shared/components/Loader/LoadingView';

function CostingComponent({ costingdata, t, nmDetail }) {
    const [editState, setEditState] = useState(null); 
    const [localCostingData, setLocalCostingData] = useState(costingdata);
    const [dataLoading, setDataLoading] = useState(false);
    const [units, setUnits] = useState([]);
    useEffect(() => {
        fetchUnits();
    }, [nmDetail.nm_id]);

    const fetchUnits = async () => {
        try {
            const response = await fetchUnitList();
            if (response.status === 200) {
                setUnits(response.data);
                await setEditState({
                    unitId: response?.data[0]?.id,
                })
            } else {
                console.error("Failed to fetch unit list:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching unit list:", error.message || error);
        }
    };
    const handleEditClick = (category) => {
        setEditState((prev) => ({ ...category, ...prev }));  
    };

    const handleSaveClick = async () => {
        if (!editState) return;
        let URL = Url.costMaster.costDataUpdateNm;
        let userId = localStorage.getItem("userId");
        let token = localStorage.getItem("springToken");
        const requestParams = {
            auth_key: token,
            user_id: userId,
        };

        const updateData = {
            id: editState.id,
            reportId: editState.costReportId,
            costTypeId: editState.costTypeId,
            costComponentId: editState.costComponentId,
            costCategoryId: editState.costCategoryId,
            lostValue: editState.lostValue,
            rateValue: editState.rateValue,
            unitId: editState.unitId || 1,
        };

        try {
            setDataLoading(true);
            const response = await Axios.put(URL, updateData, {
                params: requestParams,
                headers: {
                    "Content-Type": "application/json",
                },
            });

            console.log(response, "response");

            if (response.status === 200) {
                SuccessToast("Updated Successfully")
                const updatedItem = response.data?.data;
                setDataLoading(false)
                if (!updatedItem) {
                    console.error("No updated item found in the response");
                    return;
                }
                setLocalCostingData(prev =>
                  prev.map(item =>
                    item.id === updatedItem.id
                      ? { ...item, ...updatedItem }
                      : item
                  )
                );    
                setEditState(null);  
                 return true;
            }
        } catch (error) {
            console.error("Error adding client:", error.response?.data || error.message);
            ErrorToast(error)
            setDataLoading(false)
            throw error;
        }
    };

    return (
        <div className="clide-v2-white-box my-5 mx-4">
            {dataLoading && <LoadingView />}
            <div className="row">
                <div className="col-12 col-md-5 col-lg-5">
                    <p className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-2">
                        {t('accidentCosting')}
                    </p>
                </div>

                <div className="">
                    <Table striped bordered hover>
                        <thead style={{ color: "black" }}>
                            <tr style={{ fontSize: "16px" }}>
                                <th >Cost Type</th>
                                <th>Cost Component</th>
                                <th>Cost Category</th>
                                <th>Lost</th>
                                <th>Rate</th>
                                <th style={{ width: "50px" }}>Unit</th>
                                <th style={{ width: "50px" }}>Cost</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(
                                localCostingData?.reduce((acc, item) => {
                                    if (!acc[item.costTypeName]) {
                                        acc[item.costTypeName] = {};
                                    }
                                    if (!acc[item.costTypeName][item.costComponentName]) {
                                        acc[item.costTypeName][item.costComponentName] = [];
                                    }
                                    acc[item.costTypeName][item.costComponentName].push(item);
                                    return acc;
                                }, {})
                            ).map(([costTypeName, components], costTypeIndex) => (
                                <React.Fragment key={costTypeIndex}>
                                    {Object.entries(components).map(
                                        ([costComponentName, categories], componentIndex) => (
                                            <React.Fragment key={componentIndex}>
                                                {categories.map((category, categoryIndex) => (
                                                    <tr key={category.id} style={{ fontSize: "16px" }}>
                                                        <td>
                                                            {componentIndex === 0 && categoryIndex === 0
                                                                ? costTypeName
                                                                : ""}
                                                        </td>
                                                        <td>
                                                            {categoryIndex === 0 ? costComponentName : ""}
                                                        </td>
                                                        <td>{category.costCategoryName}</td>
                                                        <td>
                                                            {editState?.id === category.id ? (
                                                                <input
                                                                    style={{ width: "50px" }}
                                                                    value={editState.lostValue}
                                                                    onChange={(e) =>
                                                                        setEditState((prev) => ({
                                                                            ...prev,
                                                                            lostValue: e.target.value,
                                                                        }))
                                                                    }
                                                                    onInput={(e) => validateDecimal(e, 6, 2)}
                                                                    />
                                                            ) : (
                                                                category.lostValue
                                                            )}
                                                        </td>
                                                        <td>
                                                            {editState?.id === category.id ? (
                                                                <input
                                                                    style={{ width: "50px" }}
                                                                    value={editState.rateValue}
                                                                    onChange={(e) =>
                                                                        setEditState((prev) => ({
                                                                            ...prev,
                                                                            rateValue: e.target.value,
                                                                        }))
                                                                    }
                                                                    onInput={(e) => validateDecimal(e, 6, 2)}
                                                                />
                                                            ) : (
                                                                category.rateValue
                                                            )}
                                                        </td>
                                                        <td>
                                                            {editState?.id === category.id ? (
                                                                <select
                                                                    style={{ width: "50px" }}
                                                                    value={editState.unitId}
                                                                    onChange={(e) =>
                                                                        setEditState((prev) => ({
                                                                            ...prev,
                                                                            unitId: parseInt(e.target.value),
                                                                        }))
                                                                    }
                                                                >
                                                                    {units?.map((unit) => (
                                                                        <option key={unit.id} value={unit.id}>
                                                                            {unit.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            ) : (
                                                                category.unitName
                                                            )}
                                                        </td>
                                                        <td
                                                            style={{ width: "50px" }}
                                                        >{formatToTwoDecimalPlaces(category.lostValue * category.rateValue)}</td>
                                                        <td>
                                                            {editState?.id === category.id ? (
                                                                <button
                                                                    className="clide-v2-btn-template clide-v2-primary my-1 px-3"
                                                                    onClick={handleSaveClick}
                                                                >
                                                                    Save
                                                                </button>
                                                            ) : (
                                                                nmDetail.edit_flag == 1 &&
                                                                <button
                                                                    className="clide-v2-btn-template clide-v2-primary my-1 px-3"
                                                                    onClick={() => handleEditClick(category)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        )
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default CostingComponent